import { ApolloClient, NormalizedCacheObject, useQuery } from '@apollo/client'
import { ReviewsQuery, ReviewsQueryVariables } from 'types/graphql'
import { reviewsQuery } from './reviews.graphql'

interface Props {
  variables?: ReviewsQueryVariables
  pollInterval?: number
}

export const useReviews = ({ variables, pollInterval }: Props) =>
  useQuery<ReviewsQuery, ReviewsQueryVariables>(reviewsQuery, {
    variables,
    pollInterval
  })

export const preloadReviews = (apolloClient: ApolloClient<NormalizedCacheObject>, variables: ReviewsQueryVariables) =>
  apolloClient.query({
    query: reviewsQuery,
    variables
  })
